<div class="banner-games-multi-row__container scrolling-wrapper">
    <div #container class="banner-games-multi-row__games-container">
        @for (game of filteredGames(); track game.id; let index = $index) {
            <ds-card
                class="banner-games-multi-row__image-card card-aligment"
                surface="lowest"
                [elevated]="false"
                [border]="false"
                (click)="openGame.emit({ game, index })">
                <img placeholder ngSrcset="1x, 2x, 3x" [width]="80" [height]="80" [ngSrc]="game.imageUrl" />
            </ds-card>
        }
    </div>
    @if (isShowMoreVisible()) {
        <div class="banner-games-multi-row__see-more" (click)="toggleExpand()">
            <span class="text">{{ isExpanded() ? sitecore.event.ShowLess : sitecore.event.ShowMore }}</span>
            @if (isExpanded()) {
                <vn-icon name="theme-up" size="12" />
            } @else {
                <vn-icon name="theme-down" size="12" />
            }
        </div>
    }
</div>
